import { createContext, useContext } from 'react';

import { NEXT_PUBLIC_DEFAULT_APP_LOCALE } from '@/lib/const';

export const LocaleContext = createContext<string>(
  NEXT_PUBLIC_DEFAULT_APP_LOCALE,
);
export const useLocale = () => useContext(LocaleContext);
